import React, { FC } from 'react';
import { Box, Stack } from '@mui/material';
import { PageStatusResponse } from '@/declarations/models/PageStatusResponse';
import { PageStatusMetricCard } from './PageStatusMetricCard';
import { PageStatusSectionTitle } from './PageStatusSectionTitle';

type PageStatusStatusGroupCardsProps = {
  summary: PageStatusResponse['summary'];
};

export const PageStatusStatusGroupCards: FC<PageStatusStatusGroupCardsProps> = ({ summary }) => (
  <Box sx={{ mb: 3 }}>
    <PageStatusSectionTitle title='Statuskoder' helper='Gruppert etter endelig statuskode etter redirect-håndtering.' />

    <Stack direction='row' spacing={2} useFlexGap sx={{ flexWrap: 'wrap' }}>
      <PageStatusMetricCard label='2xx' value={summary.success_count} helper='Vellykket' accentColor='#8BC34A' />
      <PageStatusMetricCard label='3xx' value={summary.count_300} helper='Redirect / annet' accentColor='#FFCA28' />
      <PageStatusMetricCard label='4xx' value={summary.count_400} helper='Klientfeil' accentColor='#FFA726' />
      <PageStatusMetricCard label='5xx' value={summary.count_500} helper='Serverfeil' accentColor='#EF5350' />
      <PageStatusMetricCard
        label='N/A'
        value={summary.count_na}
        helper='Timeout / request-feil'
        accentColor='#BDBDBD'
      />
    </Stack>
  </Box>
);
